export default __webpack_public_path__ + "static/media/telegram-qr-code.7f68ed7a.svg";